export default __webpack_public_path__ + "static/media/NestleLogo.f4bff958.png";